// src/pages/Careers/components/BuildingSection.jsx
import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Users, PenTool, Code2 } from "lucide-react";
import { buildingProductsData } from "../careersData";

const iconMap = {
  Users: Users,
  PenTool: PenTool,
  Code2: Code2,
};

const BuildingSection = () => {
  return (
    <section className="py-12 md:py-14 bg-white text-gray-900 font-sans relative border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-sm font-medium border border-gray-300 rounded-full px-3 py-1 text-gray-700 bg-gray-100 mb-4 inline-block">
            Products & Projects
          </span>
          <h2 className="text-4xl md:text-5xl font-light leading-snug text-gray-900 mb-4">
            What We're Building
          </h2>
          <p className="text-lg text-gray-600 font-normal">
            Work on real products and real business problems.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {buildingProductsData.map((product, idx) => {
            const IconComponent = iconMap[product.icon] || Code2;
            return (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.15 }}
                className="group relative p-8 rounded-xl bg-white shadow-md flex flex-col justify-between"
              >
                <div>
                  {/* Top Bar with Icon & Arrow */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center text-white shadow-sm">
                      <IconComponent className="w-6 h-6" />
                    </div>
                    <div className="w-9 h-9 rounded-full bg-gray-100 text-gray-900 flex items-center justify-center">
                      <ArrowUpRight className="w-5 h-5" />
                    </div>
                  </div>

                  {/* Title & Description */}
                  <h3 className="text-xl font-semibold mb-3 text-gray-900">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 text-base leading-relaxed mb-8">
                    {product.description}
                  </p>
                </div>

                {/* Tech Tags */}
                <div>
                  <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
                    Tech Stack
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {product.tags.map((tag, tIdx) => (
                      <span
                        key={tIdx}
                        className="px-3 py-1 rounded-full text-xs font-medium bg-white text-gray-800 border border-gray-200"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BuildingSection;
